import { Outlet } from 'react-router-dom';

import { isDemoZone } from '../../components/demo/constants';
import ProjectScreenerOverlay from '../../components/ProjectScreenerOverlay';
import { usePermissions } from '../../utils/hooks/usePermissions';

import { ProjectScreenerStub } from './ProjectScreenerStub';

const ProjectScreenerGuard = () => {
  const { hasPermission } = usePermissions();
  const allowed = hasPermission('dashboard:project_screener') || isDemoZone;

  if (!allowed) {
    return (
      <>
        <ProjectScreenerStub />
        <ProjectScreenerOverlay />
      </>
    );
  }
  return <Outlet />;
};

export { ProjectScreenerGuard };
